import confirmDialogCompoment from './confirmDialog.vue'

export default {
  install (_Vue) {
    const DialogConstructor = _Vue.extend(confirmDialogCompoment)
    const instance = new DialogConstructor({
      el: document.createElement('div')
    })
    document.body.appendChild(instance.$el)
    _Vue.prototype.$alert = (title, message, submitCallback) => {
      instance.alert(title, message, submitCallback)
    }
    _Vue.prototype.$confirm = (title, message, submitCallback, cancelCallback) => {
      instance.confirm(title, message, submitCallback, cancelCallback)
    }
    _Vue.prototype.$confirmFollowBtnName = (title, message, leftTxt, rightTxt, submitCallback, cancelCallback) => {
      instance.confirmFollowBtnName(title, message, leftTxt, rightTxt, submitCallback, cancelCallback)
    }
    // _Vue.prototype.$dialog = instance
  }
}



// WEBPACK FOOTER //
// ./src/plugins/dialog/index.js